import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Banner extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { img, title, url, brandImgUrl, brandUrl },
        } = this.props;

        return (
            <div className={styles.banner_box}>
                <div className={styles.banner}>
                    <img src={img} alt="" />
                    <a href={url}>| {title}</a>
                    {brandUrl &&
                        brandImgUrl && (
                            <a href={brandUrl} target="_blank" className={styles.brandImgLink}>
                                <img
                                    className={styles.brandImgUrl}
                                    src="https://x0.ifengimg.com/ucms/2022_47/14DDFC75F7411614AB7BA05729A97C438EA94CC3_size5_w196_h80.png"
                                />
                            </a>
                        )}
                    {brandImgUrl && !brandUrl && <img className={styles.brandImgUrl} src={brandImgUrl} />}
                </div>
            </div>
        );
    }
}

export default errorBoundary(Banner);
